// Reports User Timing marks & Resource timings to Google Analytics & QTS
function reportRUM() {
  window.performance.getEntriesByType('resource')
    .filter(({ name }) => name.includes('fonts'))
    .forEach((r) => {
      _gaq.push([
        '_trackTiming', 'ResourceTimingsStartTime',
        r.name, Math.round(r.startTime)],
      );
      _gaq.push([
        '_trackTiming', 'ResourceTimingsDuration',
        r.name, Math.round(r.duration)],
      );
      _t.push(['resource_timings', {
        connectEnd: Math.round(r.connectEnd),
        connectStart: Math.round(r.connectStart),
        domainLookupEnd: Math.round(r.domainLookupEnd),
        domainLookupStart: Math.round(r.domainLookupStart),
        duration: Math.round(r.duration),
        entryType: r.entryType,
        fetchStart: Math.round(r.fetchStart),
        initiatorType: r.initiatorType,
        name: r.name,
        redirectEnd: Math.round(r.redirectEnd),
        redirectStart: Math.round(r.redirectStart),
        requestStart: Math.round(r.requestStart),
        responseEnd: Math.round(r.responseEnd),
        responseStart: Math.round(r.responseStart),
        secureConnectionStart: Math.round(r.secureConnectionStart),
        startTime: Math.round(r.startTime),
        workerStart: Math.round(r.workerStart),
      }]);
    });

  let timingMarkOffset = 0;
  const reportTimingMarks = () => {
    const marks = window.performance.getEntriesByType('mark');
    if (marks.length > timingMarkOffset) {
      for (let i = timingMarkOffset; i < marks.length; i++) {
        const mark = marks[i];
        const t = Math.round(mark.startTime);
        if (t >= 0 && t < 3600000) {
          _gaq.push(['_trackTiming', 'UserTimings', mark.name, t]);
          const p = {
            mark_name: mark.name,
            mark_time: t,
          };
          _t.push(['user_timing', p]);
        }
      }
      timingMarkOffset += marks.length;
    }
  };

  // TODO: User PerformanceObserver when it's more widely supported
  window.setInterval(() => {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(reportTimingMarks);
    }
  }, 1000);
}

// Only enable if the browser supports the User Timing API
// (http://caniuse.com/#feat=user-timing)
if (window.performance && window.performance.getEntriesByType) {
  if (document.readyState === 'complete') {
    reportRUM();
  } else {
    window.addEventListener('load', reportRUM, false);
  }
}

/**
 * Adds a 'sc-no-animation' class on the root element ('html') when a
 * 'no_animation' cookie is present. This can then be used to disable CSS
 * animations / transitions as they don't play nice with synthetics monitoring
 * & visual completness score (a.k.a. Speed Index).
 */
if (document.cookie.indexOf('no_animation=true') !== -1) {
  if (document.documentElement.classList &&
    document.documentElement.classList.add) {
    document.documentElement.classList.add('sc-no-animation');
  }
}
